import {
  showErrorNotification
} from './misc.js';

import { getUuidFrom, getIdFrom } from 'zoomforth_codesbane_viewer/lib/id_utils.js';

import { getSerializableContentDataForCopy } from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import {
  fetchAndUpdateAssetData 
} from './asset.js';

import {
  removeSection,
  beginEditSection,
  setSectionAndOverrides
} from './sections.js';

import {
  setContentItemAsset,
  createContentItem,
  createContentItemFromAsset,
  deleteContentItems
} from './content.js';

import {
  getSectionById,
  getOrderedContentUuidsForSection
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  uploadFileAndFetchAsset
} from 'zoomforth_codesbane_editor/lib/assets.js';


export const updateSingletonContentSectionWithNewContent = (sectionOrId, contentItem) =>
  (dispatch, getState) => {

    const sectionId = getIdFrom(sectionOrId);
    const section = getSectionById(getState(), sectionId);
    const contentUuid = getUuidFrom(contentItem);

    dispatch(setSectionAndOverrides(sectionId, { ...section, singletonContentUuid:contentUuid }, { isLoading: false }));
  };


export const deleteSingletonContentSection = (sectionOrId)=>
  (dispatch, getState)=> {
    // Remove section first so we dont try to render missing content
    dispatch(removeSection(sectionOrId));
    const contentUuids = getOrderedContentUuidsForSection(getState(), sectionOrId);
    dispatch(deleteContentItems(contentUuids));
  };


export const uploadFileToSingletonContentSection = (section, file, { forceAssetType = null } = {})=>
  (dispatch)=> {
    dispatch(setSectionAndOverrides(section.id, section, { isLoading: true }));

    uploadFileAndFetchAsset(file, { 
      uploadContext: 'page',
      forceAssetType: forceAssetType,
      onProgressChange:(progressData)=> {
        dispatch(setSectionAndOverrides(section.id, section, progressData));
      }, 
      onAssetReceive:(asset)=> {
        if (section.singletonContentUuid) {
          dispatch(setSectionAndOverrides(section.id, section, { isLoading: false }));
          dispatch(setContentItemAsset(section.singletonContentUuid, asset));
        } else {
          dispatch(createContentItemFromAsset(section, asset));
        }
        dispatch(beginEditSection(section));
      }, 
      onError:(errorData={})=> {
        const errorMessage = errorData.error  || 'Something went wrong while uploading your file. Please try again later.';
        dispatch(setSectionAndOverrides(section.id, section, {
          error: errorMessage,
          isLoading: false,
          isProcessing: false,
          isFetching: false,
          isUploading: false
        }));

        dispatch(showErrorNotification('Upload failed', errorMessage));
      } 
    });
  };

export const createContentItemFromContentForSingletonContentSection = (section, contentItem, postCreateData={})=>
  (dispatch)=> {
    if (contentItem.asset_type && contentItem.asset_id) {
      dispatch(fetchAndUpdateAssetData(contentItem.asset_type, contentItem.asset_id));
    }
    dispatch(createContentItem(section, getSerializableContentDataForCopy(contentItem), {}, postCreateData));
  };
